import { useRef, useEffect } from "react";
import { createRoot } from "react-dom/client";

const ConfirmationModal = ({
  title = "Are you sure?",
  message = "",
  confirmText = "Yes, Delete",
  cancelText = "No, Cancel",
  onConfirm,
  onCancel
}) => {
  const modalRef = useRef(null);

  const showModal = () => {
    const modal = new window.bootstrap.Modal(modalRef.current);
    modal.show();

    modalRef.current.addEventListener("hidden.bs.modal", () => {
      onCancel && onCancel();
    }, { once: true });
  };

  useEffect(() => {
    showModal();
  }, []);

  return (
    <div className="modal fade" ref={modalRef} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-center p-4 custom-modal">
          <button
            className="btn-close position-absolute top-0 end-0 m-3"
            data-bs-dismiss="modal"
          ></button>

          <div className="my-3">
            <div className="">
              <i className="bi bi-trash p-2 rounded-5 text-white bg-app"></i>
            </div>
          </div>

          <h4 className="fw-semibold">{title}</h4>

          {message && (
            <p className="mt-2 mb-5" dangerouslySetInnerHTML={{__html:message}}></p>
          )}

          <div className="d-flex justify-content-center gap-3">
            <button
              className="btn btn-light px-4"
              data-bs-dismiss="modal"
              onClick={onCancel}
            >
              {cancelText}
            </button>
            <button
              className="btn btn-app px-4"
              data-bs-dismiss="modal"
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

let root;
let container;

const Confirm = (options) => {
  if (!container) {
    container = document.createElement("div");
    document.body.appendChild(container);
    root = createRoot(container);
  }

  const cleanup = () => {
    root.render(null);
  };

  const handleConfirm = () => {
    if (options.onConfirm) options.onConfirm()
    cleanup();
  };

  const handleCancel = () => {
    if (options.onCancel) options.onCancel()
    cleanup();
  };

  root.render(
    <ConfirmationModal
      {...options}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );
};

export default Confirm;